<template>
  <custom-modal :size="'max-w-3xl'">
    <template v-slot:maincontent>
      <div class="mt-4 p-4 bg-theme-modalbg text-[14px] rounded-lg">
        <div class="relative">
          <h2 class="text-2xl text-white text-center pr-[40px]">Delete Audit</h2>
          <span class="absolute right-1 top-1 pointer cursor-pointer hover:opacity-60" @click.prevent="close()">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.3333 2.54602L17.4533 0.666016L10 8.11935L2.54667 0.666016L0.666672 2.54602L8.12001 9.99935L0.666672 17.4527L2.54667 19.3327L10 11.8793L17.4533 19.3327L19.3333 17.4527L11.88 9.99935L19.3333 2.54602Z" fill="white"/>
            </svg>
          </span>
        </div>

        <div class="m-2 mt-4 tracking-wider grid-cols-4 bg-theme-modal_inner_bg rounded py-2 px-2 pb-4">
          <div class="full justify-content-center">
            <p class="text-center text-white text-md mt-2">
              This action cannot be undone. Type <span class="font-bold">DELETE</span> to confirm.
            </p>
          </div>
          <div class="full flex justify-center mt-4">
            <input
              v-model="confirmInput"
              type="text"
              placeholder="Type DELETE"
              class="w-3/5 border rounded bg-[#1C1D21] text-white text-center uppercase focus:ring-0 focus:border-theme-green"
            />
          </div>
          <div class="full flex">
            <button
              @click.prevent="confirm()"
              :disabled="confirmInput.toUpperCase() !== 'DELETE'"
              class="uppercase text-white bg-theme-green hover:bg-theme-darkgreen disabled:bg-[#414141] disabled:cursor-default w-3/5 mt-6 text-lg border-0 rounded-md p-2 block mx-auto"
            >
              CONFIRM
            </button>
          </div>
        </div>

        <div class="mt-3 mb-1 text-center">
          <button @click.prevent="close()" class="text-white hover:text-theme-green text-center">CLOSE</button>
        </div>
      </div>
    </template>
  </custom-modal>
</template>

<script>
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'DeleteConfirmModal',
  emits: ['close', 'confirm'],
  setup() {
    const confirmInput = ref('')
    return { confirmInput }
  },
  methods: {
    close() {
      this.confirmInput = ''
      this.$emit('close')
    },
    confirm() {
      if (this.confirmInput.toUpperCase() === 'DELETE') {
        this.$emit('confirm')
        this.confirmInput = ''
      }
    },
  },
})
</script>
